<template>
	<!-- 详情界面 -->
	<el-dialog :visible.sync="dialogVisible" :title="title" width="80%" :close-on-click-modal="false">
		<div class="item_info border_Green">
			<el-descriptions class="margin-top" title="基本工资" :column="4" border>
				<el-descriptions-item label="所属门店"><span style="display: inline-block; width: 100px">{{ monthSalary.storeName }}</span></el-descriptions-item>
				<el-descriptions-item label="岗位名称"><span style="display: inline-block; width: 100px">{{ monthSalary.postName }}</span></el-descriptions-item>
				<el-descriptions-item label="年月"><span style="display: inline-block; width: 100px">{{ monthSalary.year }}年{{ monthSalary.month }}月</span></el-descriptions-item>
				<el-descriptions-item label="基础薪资"><span style="display: inline-block; width: 100px">{{ money2(monthSalary.baseSalary) }}</span></el-descriptions-item>
				<el-descriptions-item label="岗位工资">{{ money2(monthSalary.postWage) }}</el-descriptions-item>
				<el-descriptions-item label="全勤补贴">{{ money2(monthSalary.perfectAttendance) }}</el-descriptions-item>
				<el-descriptions-item label="社保补贴">{{ money2(monthSalary.socialSecuritySubsidy) }}</el-descriptions-item>
				<el-descriptions-item label="工龄补贴">{{ money2(monthSalary.seniorityPay) }}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info border_Green">
			<el-descriptions class="margin-top" title="浮动工资" :column="4" border>
				<el-descriptions-item label="应出勤天数"><span style="display: inline-block; width: 100px">{{ monthSalary.requiredAttendance }}</span></el-descriptions-item>
				<el-descriptions-item label="实际出勤天数"><span style="display: inline-block; width: 100px">{{ monthSalary.realAttendance }}</span></el-descriptions-item>
				<el-descriptions-item label="实发金额"><span style="display: inline-block; width: 100px" v-money="monthSalary.realMoeny">{{ money2(monthSalary.realMoeny) }}</span></el-descriptions-item>
				<el-descriptions-item label="销售提成"><span style="display: inline-block; width: 100px" v-money="monthSalary.notCardBonus">{{ money2(monthSalary.notCardBonus) }}</span></el-descriptions-item>
				<el-descriptions-item label="充卡提成"><span style="display: inline-block; width: 100px" v-money="monthSalary.cardBonus">{{ money2(monthSalary.cardBonus) }}</span></el-descriptions-item>
				<el-descriptions-item label="电话提成"><span style="display: inline-block; width: 100px" v-money="monthSalary.phoneBonus">{{ money2(monthSalary.phoneBonus) }}</span></el-descriptions-item>
				<el-descriptions-item label="跑单提成"><span style="display: inline-block; width: 100px" v-money="monthSalary.paoDanBonus">{{ money2(monthSalary.paoDanBonus) }}</span></el-descriptions-item>
				<el-descriptions-item label="进店成交提成"><span style="display: inline-block; width: 100px" v-money="monthSalary.chengJiaoBonus">{{ money2(monthSalary.chengJiaoBonus) }}</span></el-descriptions-item>
				<el-descriptions-item label="学校提成" v-money="monthSalary.schoolBonus">{{ money2(monthSalary.schoolBonus) }}</el-descriptions-item>
				<el-descriptions-item label="提成合计">
					<span style="display: inline-block; width: 100px; color: red; font-weight: bold" v-money="bonusTotal">
						{{ money2(bonusTotal) }}
					</span>
				</el-descriptions-item>
				<el-descriptions-item label="应扣款金额" v-money="monthSalary.subtractMoney">{{ money2(monthSalary.subtractMoney) }}</el-descriptions-item>
				<el-descriptions-item label="目标达成奖励" v-money="monthSalary.finishedMoney">{{ money2(monthSalary.finishedMoney) }}</el-descriptions-item>
				<el-descriptions-item label="应补发金额" v-money="monthSalary.reissueMoney">{{ money2(monthSalary.reissueMoney) }}</el-descriptions-item>
				<el-descriptions-item label="销售递增奖励" v-money="monthSalary.salesIncreasing">{{ money2(monthSalary.salesIncreasing) }}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info border_Green">
			<el-descriptions class="margin-top" title="维护信息" :column="4" border>
				<el-descriptions-item label="创建人"><span style="display: inline-block; width: 100px">{{ monthSalary.creator }}</span></el-descriptions-item>
				<el-descriptions-item label="创建时间"><span style="display: inline-block; width: 150px">{{ monthSalary.createTime }}</span></el-descriptions-item>
				<el-descriptions-item label="维护人"><span style="display: inline-block; width: 100px">{{ monthSalary.editor }}</span></el-descriptions-item>
				<el-descriptions-item label="维护时间"><span style="display: inline-block; width: 150px">{{ monthSalary.updateTime }}</span></el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info border_Green">
			<el-descriptions class="margin-top" title="导出记录" :column="4" border></el-descriptions>
			<!-- 导出历史记录 -->
			<exportHistory ref="exportHistory"></exportHistory>
		</div>
		<template #footer>
			<span>
				<el-button icon="el-icon-close" size="small" @click="dialogVisible = false">关闭</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
import { GetUserMonthSalaryDetail } from "@/api/salaryApi.js";
import exportHistory from "@/components/common/exportHistory.vue";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			dialogVisible: false, //控制详情页面显示与隐藏
			monthSalary: {}
		};
	},
	computed: {
		// 提成合计（全部 6 项：充卡/销售/电话/跑单/进店成交/学校）
		bonusTotal() {
			const m = this.monthSalary || {};
			return Number(m.cardBonus || 0) + Number(m.notCardBonus || 0) + Number(m.phoneBonus || 0) +
				Number(m.paoDanBonus || 0) + Number(m.chengJiaoBonus || 0) + Number(m.schoolBonus || 0);
		}
	},
	watch: {},
	created() {},
	mounted() {},
	components: {
		exportHistory
	},
	methods: {
		// 金额统一保留两位小数
		money2(val) {
			const num = Number(val);
			return isNaN(num) ? "0.00" : num.toFixed(2);
		},
		//显示详情界面
		detailShow(row) {
			if (row != undefined && row != "undefined") {
				this.title = "详情";
				let parmer = {
					keyId: row.keyId
				};
				GetUserMonthSalaryDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.monthSalary = res.data;
							this.dialogVisible = true;
							this.$nextTick(() => {
								this.$refs.exportHistory.showExportHistory(this.monthSalary.keyId);
							});
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("获取员工月度薪资详情失败!");
					});
			} else {
				this.$message.error("请选择要查看的员工月度薪资详情!");
			}
		},
		// 关闭详情弹出框
		closeDialog() {
			this.dialogVisible = false;
			this.$data.monthSalary = this.$options.data.call(this).monthSalary;
		}
	}
};
</script>
<style scoped>
.selectContent {
	margin-top: 20rpx;
	display: flex;
	justify-content: center;
	align-items: center;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.border_Green {
	border-left: 5px solid #00cc66;
}
</style>
